import React, { useState, useEffect } from 'react';
import axios from 'axios';

const UserMaster = () => {
  const [userData, setUserData] = useState({
    User_Name: "",
    Email: "",
    Password: "",
    Mobile_No: "",
    user_Outlate: { Outlate_Id: null, Outlet_Name: "" },
    Token: [{ token_id: 1, FootPrint: "" }],
    User_Lock: false,
    Status: true,
    Role_Id: "",
    System_User: false,
  });
  const [roleData, setRoleData] = useState([])
  const [outlets, setOutlets] = useState([]);
  
  useEffect(() => {
    const fetchOutlets = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_SERVER_API}outlates`);
        setOutlets(response.data);
      } catch (error) {
        console.error('Error fetching outlets:', error);
      }
    };
    fetchOutlets();
  }, []);

  const UserRoleAdd = async () => {
    try {
      const RoleApiResp = await axios.get(`${process.env.REACT_APP_SERVER_API}role`);
      setRoleData(RoleApiResp.data);
      console.log("Role Defined Data Get Successfully");
    } catch (error) {
      console.log("Role Defined Data Get Error", error);
    }
  };



  useEffect(() => {
    UserRoleAdd();
  }, [])

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    // Handling radio buttons
    if (type === 'radio') {
      setUserData((prevData) => ({
        ...prevData,
        [name]: value === 'true',  // Convert 'true'/'false' string to boolean
      }));
    } else {
      setUserData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }
  };

  // Handle selecting an outlet
  const handleOutlateSelect = (e) => {
    const selectedOutlateId = parseInt(e.target.value); // Get selected outlet ID
    const selectedOutlate = outlets.find(outlet => outlet.Outlate_Id === selectedOutlateId);

    // Only store Outlate_Id and Outlet_Name
    setUserData((prevData) => ({
      ...prevData,
      user_Outlate: {
        Outlate_Id: selectedOutlate?.Outlate_Id,
        Outlet_Name: selectedOutlate?.Outlet_Name,
      },
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Ensure user_Outlate is passed as an array
    const updatedUserData = {
      ...userData,
      user_Outlate: userData.user_Outlate ? [userData.user_Outlate] : [],  // Wrap in array if not already
    };

    try {
      const response = await axios.post(`${process.env.REACT_APP_SERVER_API}users`, updatedUserData);
      console.log('User Created Successfully', response.data);

      alert("User Created Successfully")
      // Reset form after successful submission
      setUserData({
        User_Name: "",
        Email: "",
        Password: "",
        Mobile_No: "",
        user_Outlate: { Outlate_Id: null, Outlet_Name: "" },
        Token: [{ token_id: 1, FootPrint: "" }],
        User_Lock: false,
        Status: true,
        System_User: true,
      });
    } catch (error) {
      console.error('Error creating user', error);
    }
  };


  return (
    <div className='container-fluid border p-3'>
      <form onSubmit={handleSubmit}>
        {/* User Name */}
        <div className="row mt-2">
          <div className="col-12 col-md-6 col-lg-4">
            <input
              type="text"
              className="form-control"
              name="User_Name"
              value={userData.User_Name}
              onChange={handleInputChange}
              required
              placeholder="User Name"
            />
          </div>
        </div>

        {/* Email */}
        <div className="row mt-2">
          <div className="col-12 col-md-6 col-lg-4">
            <input
              type="email"
              className="form-control"
              name="Email"
              value={userData.Email}
              onChange={handleInputChange}
              required
              placeholder="Email"
            />
          </div>
        </div>

        {/* Mobile No */}
        <div className="row mt-2">
          <div className="col-12 col-md-6 col-lg-4">
            <input
              type="text"
              className="form-control"
              name="Mobile_No"
              value={userData.Mobile_No}
              onChange={handleInputChange}
              required
              placeholder="Mobile No"
            />
          </div>
        </div>


        {/* Password */}
        <div className="row mt-2">
          <div className="col-12 col-md-6 col-lg-4">
            <input
              type="password"
              className="form-control"
              name="Password"
              value={userData.Password}
              onChange={handleInputChange}
              required
              placeholder="Password"
            />
          </div>
        </div>


        {/* Select Outlet */}
        <div className="row mt-2">
          <div className="col-12 col-md-6 col-lg-4">
            <select
              className="form-control"
              name="user_Outlate"
              onChange={handleOutlateSelect}
              value={userData.user_Outlate.Outlate_Id || ''}
              required
            >
              <option value="">Select Outlet</option>
              {outlets.map((outlet) => (
                <option key={outlet.Outlate_Id} value={outlet.Outlate_Id}>
                  {outlet.Outlet_Name}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="row mt-2">
          <div className="col-12 col-md-6 col-lg-4">
          <select
  className="form-control"
  name="Role_Id"
  onChange={handleInputChange}
  value={userData.Role_Id || ''}
  required
>
  <option value="">Select Role</option>
  {Array.isArray(roleData) && roleData.map((role) => (
    <option key={role.Role_Id} value={role.Role_Id}>
      {role.Role_Name}
    </option>
  ))}
</select>

          </div>
        </div>

        {/* User Lock Radio Buttons with labels */}
        <div className="row mt-4">
          <div className="col-12 col-md-6 col-lg-4 d-flex">
            <label className="me-3">User Lock</label>
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="radio"
                name="User_Lock"
                value="true"
                checked={userData.User_Lock === true}
                onChange={handleInputChange}
              />
              <label className="form-check-label">Yes</label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="User_Lock"
                value="false"
                checked={userData.User_Lock === false}
                onChange={handleInputChange}
              />
              <label className="form-check-label">No</label>
            </div>
          </div>
        </div>

        {/* Status Radio Buttons */}
        <div className="row mt-4">
          <div className="col-12 col-md-6 col-lg-4 d-flex">
            <label className="me-3">Status</label>
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="radio"
                name="Status"
                value="true"
                checked={userData.Status === true}
                onChange={handleInputChange}
              />
              <label className="form-check-label">Active</label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="Status"
                value="false"
                checked={userData.Status === false}
                onChange={handleInputChange}
              />
              <label className="form-check-label">Inactive</label>
            </div>
          </div>
        </div>

        {/* System User Radio Buttons */}
        <div className="row mt-4">
          <div className="col-12 col-md-6 col-lg-4 d-flex">
            <label className="me-3">System User</label>
            <div className="form-check me-3">
              <input
                className="form-check-input"
                type="radio"
                name="System_User"
                value="true"
                checked={userData.System_User === true}
                onChange={handleInputChange}
              />
              <label className="form-check-label">Yes</label>
            </div>

            <div className="form-check">
              <input
                className="form-check-input"
                type="radio"
                name="System_User"
                value="false"
                checked={userData.System_User === false}
                onChange={handleInputChange}
              />
              <label className="form-check-label">No</label>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <div className="form-group mt-3">
          <button type="submit" className="btn btn-primary">
            Submit
          </button>
        </div>
      </form>
    </div>
  );
};

export default UserMaster;
